export default {
	NEWS: (state, data) => {
		state.news = data
	},
	IMAGE: (state, data) => {
		state.image = data
	},
	VIDEO: (state, data) => {
		state.video = data
	},
	VOICE: (state, data) => {
		state.voice = data
	}
}


// WEBPACK FOOTER //
// ./src/store/mp/wechat/material/mutations.js